<template>
  <div v-if="covers" class="reading-list-callout">
    <button class="reading-list-callout__close" @click="clearLibraryData">
      <span class="iconfont iclose"></span>
    </button>

    <div class="reading-list-callout__text">
      <h2 class="reading-list-callout__title">
        Check your first reading list in My Library
      </h2>

      <AppButton
        tag="router-link"
        :to="{ name: 'my_library.custom_lists' }"
        class="reading-list-callout__link"
        @click="clearLibraryData"
      >
        Open My Library
      </AppButton>
    </div>

    <div class="reading-list-callout__covers">
      <img
        v-for="cover in covers.slice(0, 5)"
        :key="cover"
        :src="cover"
        width="62"
        height="83"
        alt=""
        class="reading-list-callout__cover"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { storage } from '@/helpers/storage'

import AppButton from '@/app/components/button/AppButton.vue'

const isOpen = ref(true)

const covers = computed(() => {
  const covers = storage.getItem('sf_lq_books16167')
  if (!covers || !isOpen.value) {
    return null
  }

  return JSON.parse(covers) as string[]
})

function clearLibraryData(): void {
  isOpen.value = false
  storage.removeItem('sf_lq_books16167')
}
</script>

<style lang="scss" scoped>
.reading-list-callout {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 40px 60px;
  padding-right: 80px;
  border-radius: 12px;
  background: $c-bg;
  @media (max-width: $w-tablet-s) {
    @include full-width();
    flex-direction: column-reverse;
    gap: 20px;
    padding: 28px 40px;
    border-radius: 0;
  }

  &__covers {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 8px;
  }

  &__cover {
    flex-shrink: 0;
    margin-top: -8px;
    margin-left: -8px;
    border-radius: 8px;
    border: 2px solid $c-white;
    filter: drop-shadow(-5px 4px 13px rgba(0, 0, 0, 0.15))
      drop-shadow(0 2px 8px rgba(0, 0, 0, 0.11));

    &:first-child {
      margin-left: 0;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media (max-width: $w-tablet-s) {
      align-items: center;
    }
  }

  &__title {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.02em;
    @media (max-width: $w-tablet-s) {
      font-size: 20px;
      line-height: 28px;
      text-align: center;
    }
  }

  &__link {
    width: fit-content;
    padding-inline: 16px;
    font-size: 14px;
    line-height: 18px;

    &:deep(.app-btn__content) {
      height: auto;
      padding-block: 9px 7px;
    }
  }

  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;

    .iconfont {
      font-size: 14px;
      line-height: 14px;
      width: 14px;
      height: 14px;
    }
  }
}

.night-mode .reading-list-callout {
  background: $c-dark-2;

  &__cover {
    border-color: $c-dark-2;
  }

  &__close {
    color: $c-black-4;
  }
}
</style>
